<template>
<div class="carousel-container">

    <hooper class="carousel" :settings="hooperSettings" :infiniteScroll="true" :rtl="true">
        <slide v-for="(coin,index) in sorted " :key='index'>
            <div class="container">
                <div class="card" >
                    <div class="cardbody" v-if="!loading">
                        <div class="cardhead">
                            <img class="icon" :src="require('../../../../public/coins/'+coin[0]+'.png')" />
                            <div class="title">{{$coins[coin[0]].persianName}}<span class="gray">{{$coins[coin[0]].code}}</span></div>
                        </div>
                        <div class="minmax" >
                            <span v-if="walletType=='EXCHANGE'">قیمت فروش<div class="gray">{{$toLocal(coin[1].sellPrice,0)}} تومان</div></span>
                            <span v-else>بیشترین<div class="gray">{{$toLocal(coin[1].maxPrice,0)}} تومان</div></span>
                            <span v-if="walletType=='EXCHANGE'">قیمت خرید<div class="gray">{{$toLocal(coin[1].buyPrice,0)}} تومان</div></span>
                            <span v-else>کمترین<div class="gray">{{$toLocal(coin[1].minPrice,0)}} تومان</div></span>
                        </div>
                        <div class="depsoit">
                            <div>دارایی شما</div>
                            <div class="gray">{{$toLocal(coin[1].wholePriceOfCredit,0)}} تومان</div>
                        </div>
                    </div>
                       <div class="local-loading" v-else>
                    <div class="super-spinner" />
                    </div>

                    <button v-if="coin[0]!='TOMAN'" class="btn" @click="$router.push(`/panel/AdvTrade/TOMAN/${coin[0]}`)">معامله</button>
                </div>
             

            </div>

        </slide>
        <hooper-navigation slot="hooper-addons">
            <svg slot="hooper-next" width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.5853 0.585424C14.9603 0.96048 15.1709 1.4691 15.1709 1.99943C15.1709 2.52975 14.9603 3.03837 14.5853 3.41343L5.41332 12.5854C5.04834 12.9657 4.84454 13.4724 4.84454 13.9994C4.84454 14.5265 5.04834 15.0332 5.41332 15.4134L14.5853 24.5854C14.9496 24.9626 15.1512 25.4678 15.1467 25.9922C15.1421 26.5166 14.9318 27.0183 14.561 27.3891C14.1901 27.7599 13.6885 27.9702 13.1641 27.9748C12.6397 27.9793 12.1345 27.7777 11.7573 27.4134L2.58532 18.2434C2.02806 17.6863 1.58601 17.0248 1.28442 16.2968C0.98283 15.5687 0.827602 14.7884 0.827602 14.0004C0.827602 13.2124 0.98283 12.4321 1.28442 11.7041C1.58601 10.9761 2.02806 10.3146 2.58532 9.75743L11.7573 0.585424C12.1324 0.210484 12.641 -0.000146866 13.1713 -0.000146866C13.7017 -0.000146866 14.2103 0.210484 14.5853 0.585424Z" fill="white" />
            </svg>

            <svg slot="hooper-prev" width="16" height="28" viewBox="0 0 16 28" fill="yellow" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.41467 0.585424C1.03973 0.96048 0.829102 1.4691 0.829102 1.99943C0.829102 2.52975 1.03973 3.03837 1.41467 3.41343L10.5867 12.5854C10.9517 12.9657 11.1555 13.4724 11.1555 13.9994C11.1555 14.5265 10.9517 15.0332 10.5867 15.4134L1.41467 24.5854C1.05036 24.9626 0.848769 25.4678 0.853326 25.9922C0.857883 26.5166 1.06822 27.0183 1.43904 27.3891C1.80985 27.7599 2.31148 27.9702 2.83587 27.9748C3.36027 27.9793 3.86547 27.7777 4.24268 27.4134L13.4147 18.2434C13.9719 17.6863 14.414 17.0248 14.7156 16.2968C15.0172 15.5687 15.1724 14.7884 15.1724 14.0004C15.1724 13.2124 15.0172 12.4321 14.7156 11.7041C14.414 10.9761 13.9719 10.3146 13.4147 9.75743L4.24268 0.585424C3.86762 0.210484 3.359 -0.000146866 2.82867 -0.000146866C2.29835 -0.000146866 1.78973 0.210484 1.41467 0.585424Z" fill="white" />
            </svg>
        </hooper-navigation>

    </hooper>
</div>
</template>

<script>
import {
    Hooper,
    Slide,
    Navigation as HooperNavigation
} from 'hooper';
import 'hooper/dist/hooper.css';
export default {
    name: 'Carousel',
    components: {
        Hooper,
        Slide,
        HooperNavigation,
      
    },
    props:['walletType'],
    computed: {
        sorted() {
            let entireRes = Object.entries(this.wallets)
            const sortCoins = this.$walletSortCoins
            entireRes.sort((a, b) => sortCoins.indexOf(a[0]) - sortCoins.indexOf(b[0]))
            return entireRes

        }
    },
    methods: {
        async getP2PCoins() {
            this.loading = true
            this.state.loading = true
            let cryptos
            let crypto
            const [res, ] = await this.$http.get('/wallets/customer-addresses?walletType=P2P')
            if (res) {
                this.wallets = res
            }
            await this.$axios.get('/trades/market-info', {
                params: {
                    weeklyDataIncluded: false,
                }
            }).then(response => cryptos = response.content.filter(coin => coin.marketType.includes('TOMAN')))
            for (const [key, value] of Object.entries(this.wallets)) {

                if (key !== 'TOMAN') {
                    crypto = cryptos.find(coin => coin.marketType.includes(key))
                    if (crypto) {
                        value.maxPrice = crypto.maxPrice
                        value.minPrice = crypto.minPrice
                    }
                }
                this.loading = false
                this.state.loading = false
            }

        },
        async getExchangeCoins() {
            this.loading = true
            this.state.loading = true

            let cryptos
            let crypto
            const [res, ] = await this.$http.get('/wallets/customer-addresses?walletType=EXCHANGE')
            if (res) {
                this.wallets = res
            }
            await this.$axios.get('coins/exchange-price/usd', {
                params: {
                    includeWeeklyChange: false
                }
            }).then(response => cryptos = response)

            for (const [key, value] of Object.entries(this.wallets)) {
                if (key !== 'TOMAN') {
                    crypto = cryptos.find(coin => coin.destCoinSymbol === key)
                    if (crypto) {
                        value.buyPrice = crypto.buyPrice
                        value.sellPrice = crypto.sellPrice
                       

                    }

                }
            }
            this.loading = false
            this.state.loading = false

        }
    },
    mounted() {
        this.getP2PCoins()
    },
    watch: {
        'walletType': function () {
            if (this.walletType == 'EXCHANGE')
                this.getExchangeCoins()
            else
                this.getP2PCoins()
        }
    },
    data() {
        return {
            wallets: {},
            loading: false,
            hooperSettings: {
                itemsToShow: 2,
                centerMode: false,

                breakpoints: {
                    200: {

                        itemsToShow: 1
                    },
                    340: {
                        centerMode: true,
                        itemsToShow: 2
                    },
                    650: {
                        itemsToShow: 3,
                    },
                    1100: {
                        itemsToShow: 4,

                    }
                }
            }
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>


.carousel {

    display: flex;
    align-items: center;
    min-height: 242px;
    height: 100%;
    margin-top: 20px;

    box-sizing: border-box;

}

.card {
    display: flex;
    justify-content: space-between;

    flex-direction: column;
    background: rgba(136, 136, 136, 0.05);
    border-radius: 2px;
    color: #EFEFEF;

    height: 100%;
    font-size: 16px;
}

.carousel-container {
    flex-grow: 1;

    width: 892px;
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;

}

.icon {
    width: 40px;
}

.container {
    padding: 0px 4px 0px 4px;
    height: 100%;
}

.cardhead {
    display: flex;
    flex-direction: column;
    justify-content: center;
    row-gap: 4px;
    font-size: 16px;
    font-weight: 500;

    align-items: center;
}

.btn {
    background: linear-gradient(258.51deg, #FF951F -13.62%, #F7BD68 62.17%, #FF951F 144.54%);
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    width: 100%;
    height: 41px;
}

.middle-part {
    padding: 4px;
}

.minmax {
    background: rgba(37, 67, 130, 0.06);
    border-radius: 2px;
    font-size: 12px;
    font-weight: 400;

}

.cardbody {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    padding: 6px;

    flex-direction: column;
    row-gap: 8px;
    padding-bottom: 12px;
}

.title {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 4px;
}

.depsoit {
    display: flex;
    row-gap: 4px;
    flex-direction: column;
    justify-content: center;
}

.minmax>span {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 6px;
}
</style>
